import {
  formatPercentageValue,
  createKpiTileItem,
  checkForNA,
  appendPercentage,
  formatValueWithMiddlewares,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { manufacturingFillRate, manufacturingFillRateDelta } = data;

    return createKpiTileItem(
      'MFR (Manufacturing Fill Rate)',
      formatPercentageValue(manufacturingFillRate),
      manufacturingFillRateDelta
        ? {
            isPositiveValue: manufacturingFillRateDelta >= 0,
            text: formatValueWithMiddlewares(
              Math.abs(manufacturingFillRateDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: manufacturingFillRateDelta !== 0,
          }
        : []
    );
  },
};
